import { render } from "./RulesList.vue?vue&type=template&id=0e6ade62"
import script from "./RulesList.vue?vue&type=script&lang=js"
export * from "./RulesList.vue?vue&type=script&lang=js"

import "./RulesList.vue?vue&type=style&index=0&id=0e6ade62&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__